import type { UsefulInfoDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";

const namespace = "useful_info";

export const usefulInfoDocumentColumns = [
    createStringColumn<UsefulInfoDocument>({
        namespace,
        field: "metadata.file_name",
        header: "File Name",
    }),
    createStringColumn<UsefulInfoDocument>({
        namespace,
        field: "metadata.extension",
        header: "File Extension",
    }),
    createDateColumn<UsefulInfoDocument>({
        namespace,
        field: "metadata.ingestion_date",
        header: "Ingestion Date",
    }),
];
